import { ROLE_SYMBOLS } from "@/game-lol/constants/constants.mjs";
import type { ChampionsStats } from "@/game-lol/models/lol-champions-stats.mjs";
import RoleSymbol from "@/game-lol/utils/symbol-role.mjs";
import { isRoleQueue } from "@/game-lol/utils/util.mjs";

export const patchDisplay = (
  patch: string | number,
  withLegacyName = false,
) => {
  if (!patch) return "";
  const [major, minor] = `${patch}`.split(".");
  const yearMap = {
    15: "25",
    16: "26",
    17: "27",
    18: "28",
    19: "29",
    20: "30",
  };
  const minorPrefixed = Number(minor) < 10 ? `0${minor}` : minor;
  return (
    `${yearMap[major]}.${minorPrefixed}` +
    (withLegacyName ? ` (${major}.${minor})` : "")
  );
};

export const COMMON_CHAMPIONS_PICKRATE = 0.005;

export function commonChampionsStats(
  championsStats: ChampionsStats,
  minPickrate = COMMON_CHAMPIONS_PICKRATE,
) {
  if (!championsStats?.length) return [];
  return isRoleQueue(championsStats[0].queue_id)
    ? [...championsStats].filter(
        (champion) =>
          champion.individual_position !== ROLE_SYMBOLS.all &&
          champion.champion_role_pickrate >= minPickrate,
      )
    : championsStats.filter(
        (champion) => champion.individual_position === ROLE_SYMBOLS.all,
      );
}

export function buildChampionsRoles(championsStats: ChampionsStats) {
  const roles = (championsStats || [])
    .filter((champ) => champ.individual_position !== ROLE_SYMBOLS.all)
    .sort((a, b) => b.games - a.games)
    .reduce((acc, champ) => {
      if (!acc[champ.champion_id]) acc[champ.champion_id] = [];
      acc[champ.champion_id].push({
        championId: champ.champion_id,
        pickRate: champ.champion_role_pickrate,
        role: champ.individual_position,
        rolePercentage: champ.role_pct_games,
        games: champ.games,
      });
      return acc;
    }, {});
  return roles;
}

export function getFallbackRole(championsStats: ChampionsStats = []) {
  if (!championsStats?.length) return null;
  return isRoleQueue(championsStats[0].queue_id)
    ? championsStats
        .filter((c) => RoleSymbol(c.individual_position) !== ROLE_SYMBOLS.all)
        .sort((a, b) => b.games - a.games)[0]?.individual_position
    : championsStats.find(
        (c) => RoleSymbol(c.individual_position) === ROLE_SYMBOLS.all,
      )?.individual_position;
}
